<app-relatorio-container
    tituloRelatorio="Ofício de Substituição de Diretor Técnico"
    descricaoRelatorio="Ofício solicitando indicação de novo diretor técnico"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'oficio-substituicao-diretor-tecnico-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm">O ofício é emitido para o prestador atualmente selecionado, solicitando a indicação do novo diretor técnico após o afastamento do anterior. Os campos abaixo são opcionais.</p>

            <div class="field flex flex-col gap-2">
                <label for="numeroOficio" class="text-sm font-medium">Número do ofício</label>
                <input id="numeroOficio" type="text" pInputText [(ngModel)]="numeroOficio" placeholder="Ex.: 123/2026" class="w-full" />
            </div>

            <div class="field flex flex-col gap-2">
                <label for="assinante" class="text-sm font-medium">Assinante</label>
                <input id="assinante" type="text" pInputText [(ngModel)]="assinante" placeholder="Nome do responsável pela assinatura" class="w-full" />
            </div>

            <div class="field flex flex-col gap-2">
                <label for="cargoAssinante" class="text-sm font-medium">Cargo do assinante</label>
                <input id="cargoAssinante" type="text" pInputText [(ngModel)]="cargoAssinante" placeholder="Ex.: Presidente do CRM" class="w-full" />
            </div>

            <div class="field flex items-center gap-2">
                <p-checkbox inputId="condicaoAnexo" [(ngModel)]="condicaoAnexo" [binary]="true"></p-checkbox>
                <label for="condicaoAnexo" class="text-sm">Declaração de responsabilidade técnica conforme modelo anexo (caso contrário, disponível no site do CRM)</label>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Ofício" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
